import { createContext, useState } from 'react';
import './Profile.css';
import Sidebar from './Sidebar';
import User from './User';
import ChangePassword from './ChangePassword.js';
import Modall from '../../UI/Modal.js';
import Orders from './Orders';
import Recovery from './Recovery';
import Wallet from './Wallet';
import Location from './Location';
import PIonts from './PIonts.jsx';
import Wishlist from './Wishlist.jsx';
import PasswordChange from './PasswordChange.jsx';

export const ProfileContext = createContext()

function Profile(props) {
  const [getUserName, setgetUserName] = useState("")
  const [tabChosen, setTabChosen] = useState('user')
  const [modelHander, setModelHander] = useState(false)
  const openModelHandler = () => {
    setModelHander(true)
  }
  const closeModelHandler = () => {
    setModelHander(false)
  }

  return (
    <section className='user-profile'>
      <div className='container d-flex'>
        <ProfileContext.Provider value={{ tabChosen, setTabChosen, modelHander, openModelHandler, closeModelHandler }}>
          <Sidebar getUserName={getUserName} />
        </ProfileContext.Provider>
        {tabChosen === 'user' ? <User setgetUserName={setgetUserName} /> : ''}
        {tabChosen === 'orders' ? <Orders getUserName={getUserName} tabChosen={tabChosen} /> : ''}
        {tabChosen === 'recovery' ? <Recovery getUserName={getUserName} /> : ''}
        {tabChosen === 'address' ? <Location getUserName={getUserName}/> : ''}
        {tabChosen === 'wishlist' ? <Wishlist personal={props.personal} update_p={props.update_p} getUserName={getUserName} /> : ''}
        {tabChosen === 'wallet' ? <Wallet getUserName={getUserName} /> : ''}
        {tabChosen === 'pionts' ? <PIonts getUserName={getUserName}/> : ''}
        {tabChosen === 'password' ? <PasswordChange getUserName={getUserName} /> : ''}
        {modelHander && <Modall setTabChosen={setTabChosen} modelHander={modelHander} onClose={closeModelHandler} />}
      </div>
    </section>
  )
}
export default Profile;